// extracted by mini-css-extract-plugin
module.exports = {"sticky-phone-button-wp":"ctaWp_sticky-phone-button-wp__ps_ko"};